<template>
  <b-nav-item @click="synchronize" :class="{'not-clickable': onSynchronizationPage}">
    <b-icon-wifi
        v-if="hServiceConnectivity"
        variant="success"
        v-b-tooltip.hover="$t('admin.replica.sync.connected')"
        class="menu-icon"
        
    />
    <b-icon-wifi-off
        v-else
        variant="warning"
        class="menu-icon"
        v-b-tooltip.hover="$t('admin.replica.sync.disconnected')"
    />
  </b-nav-item>
</template>

<script>
//---- components ---------
//---- mixins -------------
//---- services -----------
//---- 3rd-parties --------
import { mapGetters } from "vuex";
import {
  BIconWifi,
  BIconWifiOff,
} from "bootstrap-vue";

export default {
    name: "km-offline-menu",

    components: {
        BIconWifi,
        BIconWifiOff,
    },
    
    computed: {
        ...mapGetters({
          connectivityInfo: "kmOffline/isConnected",
        }),
        hServiceConnectivity() {
            return this.connectivityInfo?.hServiceConnectivity;
        },
        onSynchronizationPage() {
          return this.$route?.name === "kmofflineSync";
        },
    },

    methods: {
        synchronize() {
          if (this.onSynchronizationPage)
            return;
          this.safeRouterPush('/kmofflineStatus')
        }
    }
}
</script>

<style scoped>
  .not-clickable >>> a {
    cursor: default;
  }
</style>